import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Grid, Paper, Typography, Box } from "@mui/material";
import SmallCard from "examples/SmallCard";
import axios from "axios";
import axiosInstance from "../../axios";
import { useSelector } from "react-redux";
const HomePage = () => {
  const [data, setData] = useState([]);

  const getData = async () => {
    const res = await axiosInstance.post("/common/list");
    console.log("res: ", res)

    setData(res?.data?.docs);
  };

  useEffect(() => {
    getData();
  }, []);

    const {  adminData, isSuperAdmin } = useSelector((state) => ({
      t_id: state?.auth?.t_id,
      adminData: state?.auth?.adminData,
      isSuperAdmin: state?.auth?.adminData?.isSuperAdmin || false
    }));

    const hasCommonPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    [
      "jdRule", 
      "additionaltraining", 
      "city", 
      "companyTypes", 
      "departmenttype", 
      "documenttype", 
      "language", 
      "experience", 
      "specialization", 
      "professionalRegistrationTypes", 
      "professionalTypes", 
      "qualificationTypes", 
      "software"
    ].includes(perm.module)
  );

  const hasEventsPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    ["upcomingEvents", "interviewslot", "refferal"].includes(perm.module)
  );



const hasHospitalsPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    ["branch", "company", "organization", "departments", "rate"].includes(perm.module)
  );
  const hasJobPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    ["application", "job"].includes(perm.module)
  );

  const hasPermanentPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    ["permanentapplication", "permanentjob"].includes(perm.module)
  );

const hasUserPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    perm.module === "user"
  );

const hasBillingPermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    perm.module === "bill"
  );

const hasInvoicePermission = isSuperAdmin || 
  adminData?.permissions?.some(perm => 
    ["invoice", "bank"].includes(perm.module)
  );

  // const hasRewardsEnginePermission =
  //   isSuperAdmin ||
  //   adminData?.permissions?.some((perm) =>
  //     ["global_settings", "event_configuration", "referral_levels"].includes(
  //       perm.module,
  //     ),
  //   );
  const hasModulePermission = (module) => {
    if (isSuperAdmin) return true;

    if (module === "rewards_engine") {
      return adminData?.permissions?.some((perm) =>
        ["global_settings", "event_configuration", "referral_levels", "analytics"].includes(
          perm.module,
        ),
      );
    }

    return adminData?.permissions?.some((perm) => perm.module === module);
  };
  const hasRewardsEnginePermission = hasModulePermission("rewards_engine");
console.log("hasRewardsEnginePermission", hasRewardsEnginePermission);
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div>
        <MDBox mt={10} ml={2}>
          {/* Heading of Jobizo */}
          {/* <Box sx={{ borderBottom: "2px solid rgba(0,0,0,0.1)" }}>
            <Box sx={{ marginBlock: "10px" }}>
              <Typography
                sx={{
                  fontWeight: "300",
                  fontSize: "2rem",
                  color: "#000000",
                }}
              >
                The JOBIZO Super Admin
              </Typography>
            </Box>
          </Box> */}

          {/* Admin div */}
          {isSuperAdmin && (
            <Box style={{ marginBlock: "40px" }}>
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Admin</Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <SmallCard
                    title="Admin Users"
                    subTitle={`${data[1]?.adminusers} Items`}
                    route="/dashboards/admin"
                  />
                </Grid>

                {/* <Grid item xs={3}>
                <SmallCard
                  title="Roles"
                  subTitle={`${data[28]?.roles} Items`}
                  route="/dashboards/roles"
                />
              </Grid> */}
              </Grid>
            </Box>
          )}
          {/* Logs div */}
          {/* <Box style={{marginBlock:"40px"}}>
          <Box sx={{color:"#9a9a9a",marginBlock:"10px"}}>
            <Typography>Logs</Typography>
          </Box>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <SmallCard title="Audit Logs" subTitle="0 item"/>
          
          
          </Grid>
          
          
         
        </Grid>
        </Box> */}

          {/* Common div */}
          <Box style={{ marginBlock: "40px" }}>
            {hasCommonPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Common</Typography>
              </Box>
            )}
            <Grid container spacing={2}>
              {isSuperAdmin ? (
                // ✅ Show all cards if Super Admin
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Job Description"
                      subTitle={`${data[17]?.jdrules} Items`}
                      route="/common/jobDescription"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Additional Trainings"
                      subTitle={`${data[0]?.additionaltrainings} Items`}
                      route="/common/additionalTrainings"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Cities"
                      subTitle={`${data[8]?.cities} Items`}
                      route="/common/cities"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Company Types"
                      subTitle={`${data[10]?.companytypes} Items`}
                      route="/common/companyTypes"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Department Types"
                      subTitle={`${data[12]?.departmenttypes} Items`}
                      route="/common/departmentTypes"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Document Types"
                      subTitle={`${data[13]?.documenttypes} Items`}
                      route="/common/documentTypes"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Languages"
                      subTitle={`${data[19]?.languages} Items`}
                      route="/common/languages"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Experience"
                      subTitle={`${data[14]?.numexperiences} Items`}
                      route="/common/experience"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Specialization"
                      subTitle={`${data[30]?.nursetypes} Items`}
                      route="/common/specialization"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Professional Registration Types"
                      subTitle={`${data[23]?.professionalregistrationtypes} Items`}
                      route="/common/registrationTypes"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Profession"
                      subTitle={`${data[24]?.professionaltypes} Items`}
                      route="/common/profession"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Qualification"
                      subTitle={`${data[25]?.qualificationtypes} Items`}
                      route="/common/qualification"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Softwares"
                      subTitle={`${data[29]?.softwares} Items`}
                      route="/common/softwares"
                    />
                  </Grid>
                </>
              ) : (
                // ✅ Otherwise, show based on permissions
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "jdRule":
                      return (
                        <Grid item xs={3} key="jdRule">
                          <SmallCard
                            title="Job Description"
                            subTitle={`${data[17]?.jdrules} Items`}
                            route="/common/jobDescription"
                          />
                        </Grid>
                      );
                    case "additionaltraining":
                      return (
                        <Grid item xs={3} key="additionaltraining">
                          <SmallCard
                            title="Additional Trainings"
                            subTitle={`${data[0]?.additionaltrainings} Items`}
                            route="/common/additionalTrainings"
                          />
                        </Grid>
                      );
                    case "city":
                      return (
                        <Grid item xs={3} key="city">
                          <SmallCard
                            title="Cities"
                            subTitle={`${data[8]?.cities} Items`}
                            route="/common/cities"
                          />
                        </Grid>
                      );
                    case "companyTypes":
                      return (
                        <Grid item xs={3} key="companyTypes">
                          <SmallCard
                            title="Company Types"
                            subTitle={`${data[10]?.companytypes} Items`}
                            route="/common/companyTypes"
                          />
                        </Grid>
                      );
                    case "departmenttype":
                      return (
                        <Grid item xs={3} key="departmenttype">
                          <SmallCard
                            title="Department Types"
                            subTitle={`${data[12]?.departmenttypes} Items`}
                            route="/common/departmentTypes"
                          />
                        </Grid>
                      );
                    case "documenttype":
                      return (
                        <Grid item xs={3} key="documenttype">
                          <SmallCard
                            title="Document Types"
                            subTitle={`${data[13]?.documenttypes} Items`}
                            route="/common/documentTypes"
                          />
                        </Grid>
                      );
                    case "language":
                      return (
                        <Grid item xs={3} key="language">
                          <SmallCard
                            title="Languages"
                            subTitle={`${data[19]?.languages} Items`}
                            route="/common/languages"
                          />
                        </Grid>
                      );
                    case "experience":
                      return (
                        <Grid item xs={3} key="experience">
                          <SmallCard
                            title="Experience"
                            subTitle={`${data[14]?.numexperiences} Items`}
                            route="/common/experience"
                          />
                        </Grid>
                      );
                    case "specialization":
                      return (
                        <Grid item xs={3} key="specialization">
                          <SmallCard
                            title="Specialization"
                            subTitle={`${data[30]?.nursetypes} Items`}
                            route="/common/specialization"
                          />
                        </Grid>
                      );
                    case "professionalRegistrationTypes":
                      return (
                        <Grid item xs={3} key="professionalRegistrationTypes">
                          <SmallCard
                            title="Professional Registration Types"
                            subTitle={`${data[23]?.professionalregistrationtypes} Items`}
                            route="/common/registrationTypes"
                          />
                        </Grid>
                      );
                    case "professionalTypes":
                      return (
                        <Grid item xs={3} key="professionalTypes">
                          <SmallCard
                            title="Profession"
                            subTitle={`${data[24]?.professionaltypes} Items`}
                            route="/common/profession"
                          />
                        </Grid>
                      );
                    case "qualificationTypes":
                      return (
                        <Grid item xs={3} key="qualificationTypes">
                          <SmallCard
                            title="Qualification"
                            subTitle={`${data[25]?.qualificationtypes} Items`}
                            route="/common/qualification"
                          />
                        </Grid>
                      );
                    case "software":
                      return (
                        <Grid item xs={3} key="software">
                          <SmallCard
                            title="Softwares"
                            subTitle={`${data[29]?.softwares} Items`}
                            route="/common/softwares"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Events */}
          <Box style={{ marginBlock: "40px" }}>
            {hasEventsPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Events</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Event Listing"
                      subTitle={`${data[32]?.upcomingevents} Items`}
                      route="/eventDetails"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Interview"
                      subTitle={`${data[15]?.interviewslots} Items`}
                      route="/interviewDetails"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Referral"
                      subTitle={`${data[35]?.referrals} Items`}
                      route="/referralDetails"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "upcomingEvents":
                      return (
                        <Grid item xs={3} key="upcomingEvents">
                          <SmallCard
                            title="Event Listing"
                            subTitle={`${data[32]?.upcomingevents} Items`}
                            route="/eventDetails"
                          />
                        </Grid>
                      );
                    case "interviewslot":
                      return (
                        <Grid item xs={3} key="interviewslot">
                          <SmallCard
                            title="Interview"
                            subTitle={`${data[15]?.interviewslots} Items`}
                            route="/interviewDetails"
                          />
                        </Grid>
                      );
                    case "refferal":
                      return (
                        <Grid item xs={3} key="refferal">
                          <SmallCard
                            title="Referral"
                            subTitle={`${data[35]?.referrals} Items`}
                            route="/referralDetails"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Hospital */}
          <Box style={{ marginBlock: "40px" }}>
            {hasHospitalsPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Hospital</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Hospital Branch"
                      subTitle={`${data[7]?.branches} Items`}
                      route="/hospital/branch"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Corporate"
                      subTitle={`${data[9]?.companies} Items`}
                      route="/hospital/corporate"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Company"
                      subTitle={`${data[21]?.organizations} Items`}
                      route="/hospital/company"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Department"
                      subTitle={`${data[11]?.departments} Items`}
                      route="/hospital/department"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Rates"
                      subTitle={`${data[26]?.rates} Items`}
                      route="/hospital/rates"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "branch":
                      return (
                        <Grid item xs={3} key="branch">
                          <SmallCard
                            title="Hospital Branch"
                            subTitle={`${data[7]?.branches} Items`}
                            route="/hospital/branch"
                          />
                        </Grid>
                      );
                    case "company":
                      return (
                        <Grid item xs={3} key="company">
                          <SmallCard
                            title="Corporate"
                            subTitle={`${data[9]?.companies} Items`}
                            route="/hospital/corporate"
                          />
                        </Grid>
                      );
                    case "organization":
                      return (
                        <Grid item xs={3} key="organization">
                          <SmallCard
                            title="Company"
                            subTitle={`${data[21]?.organizations} Items`}
                            route="/hospital/company"
                          />
                        </Grid>
                      );
                    case "departments":
                      return (
                        <Grid item xs={3} key="departments">
                          <SmallCard
                            title="Department"
                            subTitle={`${data[11]?.departments} Items`}
                            route="/hospital/department"
                          />
                        </Grid>
                      );
                    case "rate":
                      return (
                        <Grid item xs={3} key="rate">
                          <SmallCard
                            title="Rates"
                            subTitle={`${data[26]?.rates} Items`}
                            route="/hospital/rates"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Job */}
          <Box style={{ marginBlock: "40px" }}>
            {hasJobPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Job</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Applications"
                      subTitle={`${data[2]?.applications} Items`}
                      route="/jobs/application"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Jobs"
                      subTitle={`${data[18]?.jobs} Items`}
                      route="/jobDetails"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "application":
                      return (
                        <Grid item xs={3} key="application">
                          <SmallCard
                            title="Applications"
                            subTitle={`${data[2]?.applications} Items`}
                            route="/jobs/application"
                          />
                        </Grid>
                      );
                    case "job":
                      return (
                        <Grid item xs={3} key="job">
                          <SmallCard
                            title="Jobs"
                            subTitle={`${data[18]?.jobs} Items`}
                            route="/jobDetails"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Permanent Job */}
          <Box style={{ marginBlock: "40px" }}>
            {hasPermanentPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Permanent Job</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Permanent Applications"
                      subTitle={`${data[22]?.permanentapplications} Items`}
                      route="/permanent/application"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Permanent Jobs"
                      subTitle={`${data[23]?.permanentjobs} Items`}
                      route="/permanent/job"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "permanentapplication":
                      return (
                        <Grid item xs={3} key="permanentapplication">
                          <SmallCard
                            title="Permanent Applications"
                            subTitle={`${data[22]?.permanentapplications} Items`}
                            route="/permanent/application"
                          />
                        </Grid>
                      );
                    case "permanentjob":
                      return (
                        <Grid item xs={3} key="permanentjob">
                          <SmallCard
                            title="Permanent Jobs"
                            subTitle={`${data[23]?.permanentjobs} Items`}
                            route="/permanent/job"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Transactions */}
          {/* <Box style={{ marginBlock: "40px" }}>
            <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
              <Typography>Transactions</Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={3}>
                <SmallCard
                  title="Orders"
                  subTitle={`${data[20]?.orders} Items`}
                  route="/transaction/order"
                />
              </Grid>
              <Grid item xs={3}>
                <SmallCard
                  title="Transaction"
                  subTitle={`${data[31]?.transactions} Items`}
                  route="/transaction/transactions"
                />
              </Grid>
            </Grid>
          </Box> */}

          {/* User */}
          <Box style={{ marginBlock: "40px" }}>
            {hasUserPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>User</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Nurse/Hospital User"
                      subTitle={`${data[33]?.users} Items`}
                      route="/users"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  if (perm.module === "user") {
                    return (
                      <Grid item xs={3} key="user">
                        <SmallCard
                          title="Nurse/Hospital User"
                          subTitle={`${data[33]?.users} Items`}
                          route="/users"
                        />
                      </Grid>
                    );
                  }
                  return null;
                })
              )}
            </Grid>
          </Box>

          {/* Billing */}
          <Box style={{ marginBlock: "40px" }}>
            {hasBillingPermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Billing</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Locum Bill"
                      subTitle={`${data[5]?.bills} Items`}
                      route="/locumBill"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  if (perm.module === "bill") {
                    return (
                      <Grid item xs={3} key="bill">
                        <SmallCard
                          title="Locum Bill"
                          subTitle={`${data[5]?.bills} Items`}
                          route="/locumBill"
                        />
                      </Grid>
                    );
                  }
                  return null;
                })
              )}
            </Grid>
          </Box>

          {/* User Invoices */}
          <Box style={{ marginBlock: "40px" }}>
            {hasInvoicePermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>User Invoices</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {isSuperAdmin ? (
                <>
                  <Grid item xs={3}>
                    <SmallCard
                      title="User Invoice"
                      subTitle={`${data[16]?.invoices} Items`}
                      route="/invoiceDetails"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <SmallCard
                      title="Bank"
                      subTitle={`${data[36]?.banks} Items`}
                      route="/bankDetails"
                    />
                  </Grid>
                </>
              ) : (
                adminData?.permissions?.map((perm) => {
                  switch (perm.module) {
                    case "invoice":
                      return (
                        <Grid item xs={3} key="invoice">
                          <SmallCard
                            title="User Invoice"
                            subTitle={`${data[16]?.invoices} Items`}
                            route="/invoiceDetails"
                          />
                        </Grid>
                      );
                    case "bank":
                      return (
                        <Grid item xs={3} key="bank">
                          <SmallCard
                            title="Bank"
                            subTitle={`${data[36]?.banks} Items`}
                            route="/bankDetails"
                          />
                        </Grid>
                      );
                    default:
                      return null;
                  }
                })
              )}
            </Grid>
          </Box>

          {/* Rewards Engine */}
          <Box style={{ marginBlock: "40px" }}>
            {hasRewardsEnginePermission && (
              <Box sx={{ color: "#9a9a9a", marginBlock: "10px" }}>
                <Typography>Rewards Engine</Typography>
              </Box>
            )}

            <Grid container spacing={2}>
              {hasRewardsEnginePermission && (
                <Grid item xs={3}>
                  <SmallCard
                    title="Rewards Settings"
                    subTitle="Items"
                    route="/rewards/settings"
                  />
                </Grid>
              )}
              {hasRewardsEnginePermission && (
                <Grid item xs={3}>
                  <SmallCard
                    title="Rewards Analytics"
                    subTitle="Items"
                    route="/rewards/analytics"
                  />
                </Grid>
              )}
            </Grid>
          </Box>

          {/* Others */}
        </MDBox>
      </div>
    </DashboardLayout>
  );
};

export default HomePage;
